export default "__VITE_ASSET__Djrz7IG9__"